import { styled } from '@mui/system'
import { Grid } from '@mui/material'
import Sticky from '../../particles/sticky'
import Breadcrumbs from '@bluheadless/ui/src/organisms/breadcrumbs'

export const GridContainer = styled(Grid)`
	padding: ${({ theme }) => theme.spacing(0, 0, 4)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		padding: ${({ theme }) => theme.spacing(0, 0, 5.75)};
	}
`

export const GridItem = styled(Grid)`
	padding-left: ${({ theme }) => theme.spacing(1)};
	padding-right: ${({ theme }) => theme.spacing(1)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		padding-left: 0;
		padding-right: 0;
	}
	${({ theme }) => theme.breakpoints.up('md')} {
		padding-left: ${({ pl }) => pl};
		padding-right: 0;
	}
`

export const BreadcrumbsStyled = styled(Breadcrumbs)`
	margin-top: 35px;
	padding-top: var(--spacing-3);
	padding-bottom: var(--spacing-3);
	margin-bottom: 0;
	display: flex;
	justify-content: center;
	border-top: 1px solid ${({ theme }) => theme.palette.grey.border};

	${({ theme }) => theme.breakpoints.up('md')} {
		margin-top: 85px;
		padding-top: 35px;
		padding-bottom: 35px;
	}
`

export const StickyStyled = styled(Sticky)``
